import { Box, Button, Typography } from "@material-ui/core"
import {
  DelekRecallsResponse,
  DelekWarrantyExtensionsResponse,
  WarrantyBaseData,
} from "api/delek"
import { AxiosResponse } from "axios"
import BreadCrumbsWrapper from "common/BreadCrumbs"
import { useIsDesktop } from "common/MediaQueries"
import SingleButtonSelection from "common/bit/SingleButtonSelection"
import FormikForm from "common/bit/form/FormikForm"
import FormikInput from "common/bit/form/FormikInput"
import { schemaCommon } from "common/bit/form/FormikSchema"
import { FormikValues } from "formik"
import { Dispatch, SetStateAction, useCallback, useMemo, useState } from "react"
import { StyledH3, StyledLink } from "reusable/wrappers/BodyText"
import CenterText, { StyledHeaderH1 } from "reusable/wrappers/CenterText"
import ImageContainer from "reusable/wrappers/ImageContainer"
import RecallItem from "reusable/wrappers/RecallItem"
import styled from "styled-components"
import { StyledPageWrapper } from "theme/shared"
import { ButtonType, ContentItemType } from "typings/contentPage"
import * as yup from "yup"
import TableInContent from "./TableInContent"
import SearchIcon from "./icons/SearchIcon"
import WarningIcon from "./icons/WarningIcon"
import PopUp from "./popups/PopUp"

const StyledPageDiv = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  display: flex;
  align-items: center;
  background: ${(p) => p.theme.colors.lightGrey};
  padding-bottom: 80px;
  input {
    padding-left: 0px;
    padding-right: 10px;
    background-color: white;
    &::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }
  }
  .MuiTextField-root {
    margin-top: 20px;
    width: 320px;
    ${(p) => p.theme.breakpoints.down("sm")} {
      width: 100%;
    }
  }
`

const StyledTextWrapp = styled.div`
  margin-top: 40px;
  width: 1160px;
  ${(p) => p.theme.breakpoints.down("sm")} {
    padding-right: 20px;
    padding-left: 20px;
    width: 100%;
  }
`
const StyledBody = styled(Typography).attrs({ variant: "body1" })<{
  $margin?: number
  $width?: number
}>`
  margin: auto;
  width: ${(p) => (p.$width ? `${p.$width}px` : "985px")};
  font-size: 18px;
  font-weight: 300;
  margin-top: ${(p) => (p.$margin ? `${p.$margin}px` : "10px")};
  text-align: center;
  ${(p) => p.theme.breakpoints.down("sm")} {
    text-align: right;
    width: 100%;
  }
`

const StyledLabel = styled.label<{ $activeButton: boolean }>`
  cursor: pointer;
  width: 100%;
  height: 100%;
  :focus {
    outline: none;
  }
`
const StyledButton = styled(Box)<{ $isSelected?: boolean }>`
  width: 161px;
  height: 46px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 16px;
  transition: 500ms all ease;
  background-color: ${(p) => (p.$isSelected ? "#4C607E" : "#FFF")};
  color: ${(p) => (p.$isSelected ? "#FFFFFF" : "#616161")};
  font-family: "OENaPro";
  ${(p) => p.theme.breakpoints.down("sm")} {
    width: 100%;
  }
`

const StyledButtonDiv = styled.div`
  margin-top: 40px;
  border-radius: 3px;
  border: 2px solid #4c607e;
  overflow: hidden;
  ${(p) => p.theme.breakpoints.down("sm")} {
    width: 100%;
  }
`

const StyledBtn = styled(Button)`
  background: ${(p) => p.theme.colors.headerColor};
  color: ${(p) => p.theme.colors.white};
  width: 100%;
  height: 45px;
  transition: 200ms all ease;
  border: none;
  :hover {
    background-color: ${(p) => p.theme.colors.white};
    color: ${(p) => p.theme.colors.darkBlack};
  }
`
const StyledBottomWrap = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  max-width: 1400px;
  ${(p) => p.theme.breakpoints.down("sm")} {
    padding-left: 20px;
    padding-right: 20px;
    align-items: start;
    width: 100%;
  }
`
const StyledBtnWrapp = styled.div`
  display: flex;
  margin-top: 20px;
  justify-content: center;
  ${(p) => p.theme.breakpoints.down("sm")} {
    justify-content: flex-start;
  }
`
const StyledNotFound = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
`

const StyledBottom = styled(Typography).attrs({ variant: "body1" })<{
  $margin?: number
}>`
  font-size: 18px;
  font-weight: 300;
  margin-top: 20px;
  text-align: center;
`

const StyledResponseContainer = styled(Box)<{ $isFullWidth: boolean }>`
  display: flex;
  flex-direction: column;
  margin: 45px 10px 0 10px;
  grid-gap: 40px;
  width: ${({ $isFullWidth }) => ($isFullWidth ? "100%" : "auto")};
  align-items: ${({ $isFullWidth }) => ($isFullWidth ? "center" : "right")};
  ${(p) => p.theme.breakpoints.down("sm")} {
    grid-gap: 20px;
    margin: 27px 4px 0 4px;
  }
`

const StyledWarning = styled(Box)`
  border-top: 0.5px solid ${(p) => p.theme.colors.darkGrey};
  display: flex;

  align-items: center;
  justify-content: center;
  padding-top: 32px;
  grid-gap: 8px;

  ${(p) => p.theme.breakpoints.down("sm")} {
    padding-top: 20px;
    align-items: flex-start;
  }
`

const StyledWarningText = styled.p`
  margin: 0;
  font-family: OENaPro;
  font-style: normal;
  font-weight: 300;
  font-size: 18px;
  line-height: 150%;
  color: ${(p) => p.theme.colors.black};
`

const StyledIconWrap = styled(Box)`
  width: 40px;
  height: 40px;
`

const StyledTableBottomHeader = styled.p`
  font-family: OENaPro;
  font-style: normal;
  font-weight: 300;
  font-size: 20px;
  line-height: 160%;
  letter-spacing: 0.03em;
  color: ${(p) => p.theme.colors.black};
  text-align: right;
  margin: 0;
`
const StyledListItem = styled.li`
  font-family: "OENAPRO";
  font-style: normal;
  font-weight: 300;
  font-size: 18px;
  line-height: 150%;
  text-align: right;
  list-style-type: none;
  color: ${(p) => p.theme.colors.black};
  margin-top: 20px;
  ::before {
    content: "";
    display: inline-block;
    width: 5px;
    height: 5px;
    border-radius: 50%;
    background: ${(p) => p.theme.colors.black};
    margin-left: 10px;
  }
`

type Props = {
  title: string
  background: string[]
  subtitle?: string
  buttons: ButtonType[]
  inputLabel: string
  inputType: "text" | "number"
  submitText: string
  bottomTitle: string
  phoneNumber: string
  bottomSubTitle?: string
  headerText: string[]
  getData: (
    data: string,
    selected: string
  ) => Promise<
    AxiosResponse<DelekRecallsResponse | DelekWarrantyExtensionsResponse, any>
  >
  type: ContentItemType
  tableData?: WarrantyBaseData[]
  setButtonType?: Dispatch<SetStateAction<number>>
  page?: string
  breadCrumbName?: string
}
const ContentWithForm = ({
  title,
  background,
  subtitle,
  buttons,
  inputLabel,
  inputType,
  submitText,
  bottomTitle,
  phoneNumber,
  bottomSubTitle,
  headerText,
  getData,
  type,
  tableData,
  page,
  breadCrumbName,
}: Props) => {
  const isDesktop = useIsDesktop()
  const [recallResponse, setRecallResponse] = useState<
    DelekRecallsResponse | DelekWarrantyExtensionsResponse | null
  >(null)
  const [selectedButton, setSelectedButton] = useState(buttons[0].value)
  const [inputValue, setInputValue] = useState(null)
  const [notFound, setNotFound] = useState(false)

  const handleButtonClick = (buttonValue: string) => {
    setSelectedButton(buttonValue)
  }
  const [modalOpen, setModalOpen] = useState(false)

  const renderButtons = (
    radioId: string,
    isSelected: boolean,
    item: ButtonType
  ) => (
    <StyledLabel htmlFor={radioId} $activeButton={isSelected}>
      <StyledButton $isSelected={isSelected}>
        <>{item.name}</>
      </StyledButton>
    </StyledLabel>
  )

  const handleModalClose = () => {
    setModalOpen(false)
    setRecallResponse(null)
  }

  const initialValuesFromButtons: FormikValues = buttons.reduce(
    (obj, item) => Object.assign(obj, { [item.value]: "" }),
    {}
  )

  const schemaCard = useMemo(
    () =>
      yup.object().shape({
        [selectedButton]:
          selectedButton === "licenseNumber"
            ? schemaCommon.licenseNumber
            : schemaCommon.chassis,
      }),
    [selectedButton]
  )

  const renderForm = ({ setFieldValue, values, setFieldTouched }) => (
    <>
      <FormikInput
        value={values[selectedButton]}
        name={selectedButton}
        id={selectedButton}
        autoComplete="off"
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
          setFieldTouched("licenseNumber")
          setFieldValue(selectedButton, e.target.value)
        }}
        numeric={selectedButton === "licenseNumber" ? true : false}
        label={
          page
            ? `מספר ${
                selectedButton === "licenseNumber" ? "רישוי" : "שילדה"
              } (הקלדת מס׳ משמאל לימין)`
            : inputLabel
        }
        type={selectedButton === "licenseNumber" ? "number" : inputType}
      />
      <StyledBtnWrapp>
        <StyledBtn type="submit">{submitText}</StyledBtn>
      </StyledBtnWrapp>
    </>
  )

  const handleSubmit = async (values: FormikValues) => {
    const { data } = await getData(values[selectedButton], selectedButton)
    setInputValue(values[selectedButton])
    setRecallResponse(data)
    setNotFound(data?.data.length ? false : true)
    setModalOpen(true)
  }

  const getEmptyResponseByTypeAndSelectedButton = useCallback(() => {
    let emptyText = ""
    const selectedButtonText =
      selectedButton === "licenseNumber" ? "רכב מספר" : "שילדה מספר"
    switch (type) {
      case ContentItemType.COLOR:
        emptyText = `לא נמצא קוד צבע עבור ${selectedButtonText}`
        break
      case ContentItemType.SERVICE:
        emptyText = `לא נמצאה הוראת שירות עבור ${selectedButtonText}`
        break
      case ContentItemType.WARRANTYEXTENSION:
        emptyText = `לא נמצאה הארכת אחריות עבור ${selectedButtonText}`
        break
      default:
        emptyText = `לא נמצאה הוראת שירות עבור ${selectedButtonText}`
        break
    }
    return emptyText
  }, [type, selectedButton])

  return (
    <StyledPageWrapper $padding="0">
      {/* Modal to show response data START */}
      <PopUp
        open={modalOpen}
        setOpen={handleModalClose}
        width={notFound && 320}
      >
        {recallResponse?.data.length ? (
          <StyledResponseContainer
            $isFullWidth={type === ContentItemType.COLOR}
          >
            {recallResponse.data.map((item, index) => (
              <RecallItem
                item={item}
                key={index.toString()}
                type={type}
                length={recallResponse.data.length}
              />
            ))}
            {type !== ContentItemType.COLOR ? (
              <StyledWarning>
                <StyledIconWrap>
                  <WarningIcon />
                </StyledIconWrap>
                <StyledWarningText>
                  שים לב, יש לתאם מראש טלפונית את מועד הגעתך למרכז השירות,
                  לרשימת מרכזי שירות{" "}
                  <StyledLink $color="#4C607E" href={"/services-centers"}>
                    לחצו כאן
                  </StyledLink>{" "}
                </StyledWarningText>
              </StyledWarning>
            ) : null}
          </StyledResponseContainer>
        ) : (
          <StyledNotFound>
            <SearchIcon />
            <StyledHeaderH1 $margin={7.5} $align="center">
              {getEmptyResponseByTypeAndSelectedButton()}
            </StyledHeaderH1>
            <StyledHeaderH1 $margin={20} $break={"break-all"}>
              {inputValue}
            </StyledHeaderH1>
            <StyledBottom $margin={20}>
              מאחלים לכם נסיעה טובה ועומדים לרשותכם בכל עת
            </StyledBottom>
          </StyledNotFound>
        )}
      </PopUp>
      {/* Modal to show response data END */}
      <StyledPageDiv>
        <ImageContainer src={isDesktop ? background[1] : background[0]} />
        <BreadCrumbsWrapper name={breadCrumbName} />
        <StyledTextWrapp>
          <CenterText
            headerText={headerText}
            title={title}
            withBorder={!!subtitle}
            page={page}
          />
          {tableData ? <TableInContent data={tableData} /> : null}
          {subtitle ? (
            <StyledBody $margin={40} $width={410}>
              {subtitle}
            </StyledBody>
          ) : null}
        </StyledTextWrapp>
        <StyledBottomWrap>
          <StyledButtonDiv>
            <SingleButtonSelection
              id="routesSelect"
              items={buttons}
              onSelect={handleButtonClick}
              gap={15}
              itemsPerRow={"auto"}
              customButton={renderButtons}
            />
          </StyledButtonDiv>

          {/* Form with input to submit data */}
          <FormikForm
            initialValues={initialValuesFromButtons}
            validationSchema={schemaCard}
            onSubmit={handleSubmit}
            render={renderForm}
          />

          {tableData ? null : (
            <>
              <StyledH3>{bottomTitle}</StyledH3>
              <StyledLink
                href={`tel: ${phoneNumber}`}
                $margin={10}
                $color={"#4C607E"}
                style={{ unicodeBidi: "plaintext" }}
              >
                {phoneNumber}
              </StyledLink>
              {bottomSubTitle ? (
                <StyledBody $margin={40} $width={780}>
                  {bottomSubTitle}
                </StyledBody>
              ) : null}
            </>
          )}
        </StyledBottomWrap>
        {tableData ? (
          <StyledTextWrapp>
            <StyledTableBottomHeader>לתשומת ליבך</StyledTableBottomHeader>
            <StyledListItem>
              האפשרות להארכת האחריות על ידי היצרן מוצגת לידיעה כללית בלבד.
              תחולתה של הארכת האחריות ביחד לרכב מסוים תיבחן ותיקבע באופן פרטני
              בהתאם להגדרות היצרן בהיבט זמן/מד אוץ, אופי התקלה וסייגים נוספים
              כפי שקבע ביצרן במועד הבאתו של הרכב אל מרכז שירות מורשה.
            </StyledListItem>
            <StyledListItem>
              <StyledLink href="/services-centers" $color=" #4C607E">
                לאיתור מרכז שירות מורשה
              </StyledLink>
            </StyledListItem>
            <StyledListItem>
              לכל שאלה ניתן לפנות למוקד שירות הלקוחות בטלפון{" "}
              <StyledLink
                $color=" #4C607E"
                href={"tel:*2880"}
                style={{ unicodeBidi: "plaintext" }}
              >
                *2880
              </StyledLink>{" "}
              או בכתובת הדואר האלקטרוני{" "}
              <StyledLink
                $color=" #4C607E"
                href={"mailto:service1@delekmotors.co.il"}
              >
                service1@delekmotors.co.il
              </StyledLink>
            </StyledListItem>

            <StyledListItem>
              משך האחריות נמדד ממועד עליית הרכב לכביש.
            </StyledListItem>
          </StyledTextWrapp>
        ) : null}
      </StyledPageDiv>
    </StyledPageWrapper>
  )
}

export default ContentWithForm
